import { ExistingProvider, inject, Injectable } from '@angular/core';
import { environment } from '@portal/env';
import { MapApiService } from 'src/app/services/api/map-api.service';
import { AosMapConfig, AosMapConfigToken, FocusAreaDataSource } from '@portal/shared/components/map/map.types';

@Injectable({ providedIn: 'root' })
export class AlarmsMapConfig implements AosMapConfig {
  readonly #mapApi = inject(MapApiService);

  readonly tileEndpoint = environment.map.mapAlarmsGeoUrl;
  readonly itemsCountFieldName = 'alarmCount';
  readonly focusAreaDataSource: FocusAreaDataSource = {
    get: payload => this.#mapApi.getAlarmsFocusArea(payload)
  };
}

export const alarmsMapConfigProvider: ExistingProvider = {
  provide: AosMapConfigToken,
  useExisting: AlarmsMapConfig
};
